import { render, staticRenderFns } from "./ProminentStats.vue?vue&type=template&id=3391cbd2&scoped=true&"
import script from "./ProminentStats.vue?vue&type=script&lang=js&"
export * from "./ProminentStats.vue?vue&type=script&lang=js&"
import style0 from "./ProminentStats.vue?vue&type=style&index=0&id=3391cbd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3391cbd2",
  null
  
)

export default component.exports